/**
 * Logic `fire_basic_coverage` field
 * which depends on `basic_coverage_postcode_validation_building`
 * from quote response.
 */
export default (kasko) => {
  kasko.addEventListener(
    'state-changed',
    (validation) => {
      const { flags, input } = kasko.getState();

      // edge case when user opens webapp from save for later email
      // in that way dont need to do anything on first `quote` response,
      // because it comes from data which were entered when user created save for later
      if (validation !== undefined && flags.lead_token_valid && input.access_pin_flag) {
        kasko.dispatchEvent('set-state-input', {
          access_pin_flag: false,
        });

        return;
      }

      if (validation === true || validation === false) {
        kasko.dispatchEvent('set-state-input', {
          fire_basic_coverage_quote_settings: validation,
          fire_basic_coverage: validation,
        });
        kasko.dispatchEvent('set-form-input', {
          fire_basic_coverage: validation,
          fire_basic_coverage_quote_settings: validation,
        });
        kasko.dispatchEvent('trigger-requests');
      }
    },
    { slice: 'quote.data.extraData.basic_coverage_postcode_validation_building' },
  );
};
